import translations from './const/en.json';

const en = {
  translation: {
    ...translations
  }
}

export default en;